import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import {
  IconButton,
  IconMoreVert,
  Menu,
  MenuListItem,
} from 'cdk-radial';
import './ViewLocations.scss';
import { ManageDMS } from './ManageDMS';
import { resetSubscribeRequestSentFlag } from '../../../../../../redux/connectedComponent/daabSubscriptions/daabSubscriptions.slice';

export const CustomMenu = ({ gridParams, apiDms, apiData, app }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogData, setDialoagData] = useState({});
    const dispatch = useDispatch();
    const { subscribeRequestSent } = useSelector((state) => state.daabSubscriptionsSlice);
  
    const {
      orgId: locationId,
      cmf,
      dms,
      entityName,
      address,
      storeId
    } = gridParams.data;
  
    const targetRef = useRef();
    const options = [{ label: 'Manage DMS' }];
  
    const handleSelect = (option) => {
      setMenuOpen(false);
      setSelectedOption(option);
      targetRef.current.focus();
      if (option.label === 'Manage DMS') {
        if (subscribeRequestSent) {
          dispatch(resetSubscribeRequestSentFlag());
        }
        setDialoagData({
          locationId,
          subscribeRequest: {
            [locationId]: {
              dmsConfig: dms,
            },
          },
          locationData: {
            entityId: locationId,
            location: entityName,
            address: address,
            cmfNumber: cmf,
            storeId: storeId
          },
          existingSubscriptions: gridParams.data
        });
        setOpenDialog(true);
      }
    };
  
    const handleOpen = () => {
      setMenuOpen(true);
    };
  
    const handleClose = () => {
      setMenuOpen(false);
      setSelectedOption({});
    };
  
    const closeDialog = () => {
      setDialoagData({});
      setOpenDialog(false);
    };
  
    return (
      <>
        <IconButton
          icon={<IconMoreVert />}
          ref={targetRef}
          style={{
            position: 'sticky',
          }}
        />
        <Menu
          dataTestId="menu-container-view-location"
          labelRef={targetRef}
          isAuto={true}
          onClose={handleClose}
          onOpen={handleOpen}
          className={'view-location-menu-options'}
        >
          {options.map((option, index) => (
            <MenuListItem
              dataTestId={`menu-item-${index}`}
              isSelected={selectedOption.label === option.label}
              key={`menu-${JSON.stringify(option)}`}
              onClick={() => handleSelect(option)}
              hideSelectedItemCheckmark={true}
            >
              {option.label}
            </MenuListItem>
          ))}
        </Menu>
        {openDialog ? (
          <ManageDMS
            handleClose={closeDialog}
            data={dialogData}
            apiDms={apiDms}
            apiData={apiData}
            app={app}
          />
        ) : null}
      </>
    );
  };
  